import * as R from 'ramda'

/**
 * This is the store module for bulk actions
 */
export default {
  namespaced: true,
  state: () => ({
    selectedItems: [],
    isSelectionLocked: false
  }),
  mutations: {
    SET_ITEMS(state, items) {
      state.selectedItems = items
    },
    TOGGLE_ITEM(state, item) {
      const selectedItems = state.selectedItems
      const isPresent = selectedItems.find(i => item === i)
      if (isPresent) {
        state.selectedItems = selectedItems.filter(i => item !== i)
      } else {
        selectedItems.push(item)
        state.selectedItems = R.uniq(selectedItems)
      }
    },
    ADD_ITEMS(state, items) {
      const selectedItems = state.selectedItems.concat(items)
      state.selectedItems = R.uniq(selectedItems)
    },
    DISMISS(state) {
      state.selectedItems = []
    },
    SET_SELECTION_LOCK(state, isLocked) {
      state.isSelectionLocked = isLocked
    }
  },
  getters: {
    selectedItems: state => state.selectedItems,
    isBulkSelectionActive: state => state.selectedItems.length > 1,
    isSelectionLocked: state => state.isSelectionLocked
  },
  actions: {}
}
